import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';

import './injectGlobal';

import configureStore from './configureStore';
import Root from './modules/core/Root';

import registerServiceWorker from './registerServiceWorker';

const { store, persistor } = configureStore();

render(
  <Root store={store} persistor={persistor} />,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js